import { useEffect } from 'react';

function useEventListener(name, handler, target, options = {}) {
  let disabled = false;
  if (typeof options === 'object') {
    disabled = !!options?.disabled;
  }

  useEffect(() => {
    if (disabled || !handler) {
      return;
    }

    const targetElement = target?.addEventListener
      ? target
      : target?.current || window;
    if (!(targetElement && targetElement.addEventListener)) {
      return;
    }

    targetElement.addEventListener(name, handler, options);

    return () => {
      targetElement.removeEventListener(name, handler);
    };
  }, [name, handler, target, options]);
}

export default useEventListener;
